import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { PaymentApiService } from '../services/payment-api.service';
import { UserApiService } from '../services/user-api.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css']
})
export class PricingComponent {
  showMessage = false;
  message = "";
  alertType: number = 1;
  basicUrl = "#"
  proUrl = "#"
  enterpriseUrl = "#"
  userToken: any;
  currentPlan = ""

  constructor(@Inject(DOCUMENT) private document: Document, private router: Router, private titleService: Title, private paymentApiService: PaymentApiService, private userApiService: UserApiService) {
    this.titleService.setTitle("Pricing | RankAhead");
  }

  ngOnInit() {
    this.document.body.classList.add('toggle-sidebar');
    this.userToken = localStorage.getItem("ut");

    if (this.userToken != null) {
      this.getUserSubscriptionPlan();
    }
  }

  getPaymentLinks(plan: any) {
    this.paymentApiService.getPaymentLinks().subscribe((response: any) => {
      if (plan == "basic") {
        window.location.href = response[0];
      }
      else if (plan == "pro") {
        window.location.href = response[1];
      }
      else if (plan == "enterprise") {
        window.location.href = response[2];
      }
    })
  }

  getUserSubscriptionPlan() {
    this.userApiService.getUserSubscriptionPlan().subscribe((response: any) => {
      if (response != null && response.plan != null) {
        this.currentPlan = response.plan
      }
    });
  }

  showAlert(alertType: number, message: string) {
    this.alertType = alertType;
    this.message = message;
    this.showMessage = true;

    setTimeout(() => {
      this.showMessage = false;
      this.message = "";
    }, 5000);
  }

  manageSubscription() {
    this.paymentApiService.createCustomerPortalLink().subscribe((response: any) => {
      location.href = response;
    }, (error: any) => {
      this.showAlert(0, "An error occured.");
    })
  }
}
